module.exports = __webpack_public_path__ + "img/care-offer-4.8018cc37.jpg";